
<template>
    <div id="addView1">
      <el-header>
          <top-Nav></top-Nav>
      </el-header>

      <div class="monitor_wrap el-main">
        <div class="mainHead ">
          <div class="route">
            <span class="crumbs"></span><span>基础数据</span><span class="arrow">></span><span>3d配置</span>
          </div>
        </div>
        <div class="fixedScorll" :style="{height: heightCard + 'px'}">
          <div class="maindetails" :style="{height: heightBg + 'px'}">
              <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm" >
                  <el-form-item label="楼栋:" prop="monitoringName"  :show-message="false" class="demo-ruleForm1"> 
                      <el-input  v-model="ruleForm.buildingX" type="number" placeholder="X轴旋转角度"></el-input>
                      <el-input  v-model="ruleForm.buildingY" type="number" placeholder="Y轴旋转角度"></el-input>
                      <el-input  v-model="ruleForm.buildingZ" type="number" placeholder="半径的倍数"></el-input>
                  </el-form-item>
                  <el-form-item >
                      <el-button style="margin-top:20px;margin-bottom:30px;" type="primary" @click="submitFormB()">保存</el-button>
                  </el-form-item>
                  <el-form-item label="楼层:" prop="monitoringName"  :show-message="false" class="demo-ruleForm1"> 
                      <el-input  v-model="ruleForm.floorX" type="number" placeholder="X轴旋转角度" :maxlength="20"></el-input>
                      <el-input  v-model="ruleForm.floorY" type="number" placeholder="Y轴旋转角度" :maxlength="20"></el-input>
                      <el-input  v-model="ruleForm.floorZ" type="number" placeholder="半径的倍数" :maxlength="20"></el-input>
                  </el-form-item>
                  <el-form-item >
                      <el-button style="margin-top:20px;margin-bottom:30px;" type="primary" @click="submitFormF()">保存</el-button>
                  </el-form-item>
                  <el-form-item label="路径:" prop="monitoringName"  :show-message="false"> 
                      <el-input  v-model="ruleForm.enabled" placeholder="输入3d地址"></el-input>
                  </el-form-item>
                  <el-form-item >
                      <el-button style="margin-top:20px;margin-bottom:30px;" type="primary" @click="submitForm()">保存</el-button>
                  </el-form-item>

              </el-form>
          </div>
        </div>
    
      </div>




    </div>
</template>

<script>
  import topNav from '../../components/TopNav';
    import {ajaxFuncJson} from '@/api/ajax';
    export default {
        name: 'addView',
        props:['infoId'],
        components: {
            topNav,
        },
        data() {
            return {
                heightCard:'',
                heightBg:'',
                activeIndex:"'4-1'", //Top导航选中值
                ruleForm: { //表单提交数据
                    buildingX: '', //楼栋x
                    buildingY: '', //楼栋Y
                    buildingZ: '', //楼栋Z倍数
                    floorX: '', //楼层x
                    floorY: '', //楼层Y
                    floorZ: '', //楼层Z倍数
                    enabled: '', //路径
                },
                dialogTipsVisible:false, //自动消失提示
                dialogTipsSureVisible:false, //确认提示
                tips:'信息填写不完善，请完善信息！', //提示语
                windowResize:null,

            }
        },
        watch: {

        },
        created() {
          this.getAngle()
          this.getUrl()
        },
        methods: {
          openhint(obj,obj1) {
            if(obj1==1){
              this.$message.error(obj);
            }else if(obj1==2){
              this.$message({
                message: obj,
                type: 'success'
              });
            }
            
          },

          // 返回监测点管理
          returnBtn(){
             this.$router.push({path:'/content/BasicData'}); //监测点首页
          },
          // 楼栋点击保存
          submitFormB(){
            if(this.ruleForm.buildingX==''){
              this.openhint('楼栋x轴角度不可为空！',1);
              return;
            }else if(this.ruleForm.buildingY==''){
              this.openhint('楼栋y轴角度不可为空！',1);
              return;
            }else if(this.ruleForm.buildingZ==''){
              this.openhint('楼栋半径的倍数不可为空！',1);
              return;
            }
            this.savaAngle(2);
          },
          // 楼层点击保存
          submitFormF(){
            if(this.ruleForm.floorX==''){
              this.openhint('楼层x轴角度不可为空！',1);
              return;
            }else if(this.ruleForm.floorY==''){
              this.openhint('楼层y轴角度不可为空！',1);
              return;
            }else if(this.ruleForm.floorZ==''){
              this.openhint('楼层半径的倍数不可为空！',1);
              return;
            }
            this.savaAngle(3);
          },
          // 点击保存
          submitForm(){
            if(this.ruleForm.enabled==''){
              this.openhint('路径不可保存空！',1);
              return;
            }
            this.savaUrl();
          },
          // 存取3d角度
          savaAngle(obj){ //确认提示
            let parms;
            if(obj==2){
              parms={
                  xAxis:this.ruleForm.buildingX,
                  yAxis:this.ruleForm.buildingY,
                  zAxis:this.ruleForm.buildingZ,
                  type: 2  //2是楼栋，3是楼层
              }
            }else if(obj==3){
              parms={
                  xAxis:this.ruleForm.floorX,
                  yAxis:this.ruleForm.floorY,
                  zAxis:this.ruleForm.floorZ,
                  type: 3  //2是楼栋，3是楼层
              }
            }
           
            ajaxFuncJson('/thingjs/savaAngle',parms).then(res=>{
                if(res.data.status == 200){
                  if(obj==2){
                    this.openhint('楼栋视角更新成功',2);

                  }else if(obj==3){
                    this.openhint('楼层视角更新成功',2);
                  }
                }else{
                  this.openhint('接口错误',1);
                }
            })
          },
          // 查询3d角度
          getAngle(){ //确认提示
            let parms={
                Type:null,
            }
            ajaxFuncJson('/thingjs/getAngle',parms).then(res=>{
                if(res.data.status == 200){
                    if(!res.data.data)return;
                    res.data.data.forEach((item,index)=>{
                      if(item.type==2){
                        this.ruleForm.buildingX = item.xAxis;
                        this.ruleForm.buildingY = item.yAxis;
                        this.ruleForm.buildingZ = item.zAxis;
                      }else if(item.type==3){
                        this.ruleForm.floorX = item.xAxis;
                        this.ruleForm.floorY = item.yAxis;
                        this.ruleForm.floorZ = item.zAxis;
                      }
                    })

                }else{
                  this.openhint('接口错误',1);
                }
            })
          },
          //存URL
          savaUrl(){ //确认提示
            let parms={
              thingjsUrl:this.ruleForm.enabled
            }
            ajaxFuncJson('/thingjs/savaUrl',parms).then(res=>{
                if(res.data.status == 200){
                  this.openhint('地址更新成功',2);
                }else{
                  this.openhint('接口错误',1);
                }
            })
          },
          // 查询URL
          getUrl(){ //确认提示
            let parms={}
            ajaxFuncJson('/thingjs/getUrl',parms).then(res=>{
                if(res.data.status == 200){
                  if(!res.data.data)return;
                  this.ruleForm.enabled = res.data.data.thingjsUrl;
                }else{
                  this.openhint('接口错误',1);
                }
            })
          },


        },
        mounted() {
     
        },
        destroyed(){
        
        }
    }
</script>

<style scoped lang="scss">
@import "@/assets/css/mixin.scss";
// 内容布局
.el-main{
   width: 98%;
      margin: auto;
      margin-top: 10px;
      overflow: hidden;
  .maindetails{
      min-height: 800px;
      margin: 10px 0px;
      background-color:#fff;
  }
}

.txtcolor span{
    color: #282828;
}
.el-input{
  width:130px !important;
}
.txtcolor span{
    color: #282828;
}
.el-input{
  width:130px !important;
}


</style>



// WEBPACK FOOTER //
// src/page/addViewX/index.vue